import React from "react";
import { Logo } from "./Logo";
import { Instagram, Twitter, Youtube, Linkedin } from "lucide-react";

const COLUMNS = [
    {
        title: "Platform",
        links: [
            "Distribution",
            "Monetization",
            "Analytics",
            "Collaboration",
            "Creator tools",
        ],
    },
    {
        title: "Company",
        links: ["About", "Press", "Careers", "Contact", "Blog"],
    },
    {
        title: "Resources",
        links: [
            "Help center",
            "Artist guide",
            "API docs",
            "Status",
            "Community",
        ],
    },
    {
        title: "Legal",
        links: ["Terms", "Privacy", "Cookies", "Licensing", "DMCA"],
    },
];

const SOCIALS = [
    { icon: Instagram, label: "Instagram" },
    { icon: Twitter, label: "Twitter" },
    { icon: Youtube, label: "YouTube" },
    { icon: Linkedin, label: "LinkedIn" },
];

export const Footer = () => {
    return (
        <footer
            className="relative border-t border-white/10 bg-[#030023] pt-20 pb-10"
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12 mb-16 items-start">
                    {/* Logo + tagline */}
                    <div>
                        <Logo size="default" />
                        <p className="mt-6 text-white/55 max-w-xs font-body leading-relaxed">
                            A global brand for the next generation of
                            independent music makers.
                        </p>
                        <div className="mt-8 flex gap-3">
                            {SOCIALS.map((s) => (
                                <a
                                    key={s.label}
                                    href="#"
                                    aria-label={s.label}
                                    className="w-10 h-10 rounded-full border border-white/10 hover:border-[#791EE2] hover:bg-[#791EE2]/15 flex items-center justify-center text-white/70 hover:text-white transition-all"
                                    data-testid={`footer-social-${s.label}`}
                                >
                                    <s.icon size={16} />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <p className="text-white/40 text-sm">
                        © {new Date().getFullYear()} Maajja. All rights
                        reserved. Built for artists.
                    </p>
                    <div className="flex items-center gap-2 text-white/50 text-sm">
                        <span className="w-2 h-2 rounded-full bg-[#F54815] animate-pulse" />
                        <span className="tracking-wide">
                            Streaming worldwide
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
